<template>
  <div class="home">
    <div class="imgbox">
      <!-- 最外层div设置为绝对定位 -->
      <div style="position: absolute;">
        <img class="box-img" src="../assets/banner2.png">
        <div class="box-font">网上竞价</div>
      </div>
    </div>
    <article class="newhome" v-cloak style="padding-bottom: 100px;">
      <div style="display: flex;margin-top: 40px;">
        <div style="margin-left: 20px;padding:20px; width:100%; border: 1px solid #CCCCCC;">
          <table width="100%" border="0" align="center" cellpadding="0" cellspacing="0">
            <tbody>
              <tr>
                <td width="295" height="28" align="right"><span style="font-weight: bold">期 　数：</span></td>
                <td width="360" style="padding-left:10px">{{ detail.Title }}</td>
              </tr>
              <tr>
                <td height="28" align="right"><span style="font-weight: bold">采购项目名称：</span></td>
                <td width="560" style="padding-left:10px">{{ detail.Name }}</td>
              </tr>
              <tr>
                <td height="28" align="right"><span style="font-weight: bold">采购类型：</span></td>
                <td width="360" style="padding-left:10px">{{ detail.PurchaseType }}</td>
              </tr>
              <tr>
                <td height="28" align="right"><strong>中标方式：</strong></td>
                <td style="padding-left:10px"><strong>
                    <font color="#0000DC">{{ detail.TenderType == 1 ? '低价中标' : '高价中标' }}</font>
                  </strong></td>
              </tr>
              <tr>
                <td height="28" align="right"><span style="font-weight: bold">合同包总数：</span></td>
                <td style="padding-left:10px">{{ detail.ContractTotal }}</td>
              </tr>
              <tr>
                <td height="28" align="right"><span style="font-weight: bold">报名起始时间：</span></td>
                <td style="padding-left:10px">{{ detail.BBeginTime }}</td>
              </tr>
              <tr>
                <td height="28" align="right"><span style="font-weight: bold">报名截止时间：</span></td>
                <td style="padding-left:10px">{{ detail.BEndTime }}</td>
              </tr>
              <tr>
                <td height="28" align="right"><span style="font-weight: bold">竞价起始时间：</span></td>
                <td style="padding-left:10px">{{ detail.JBeginTime }}</td>
              </tr>
              <tr>
                <td height="28" align="right"><span style="font-weight: bold">竞价截止时间：</span></td>
                <td style="padding-left:10px">{{ detail.JEndTime }}</td>
              </tr>
              <tr>
                <td height="28" align="right"><span style="font-weight: bold">文件上传起始时间：</span></td>
                <td style="padding-left:10px">{{ detail.UPBeginTime }}</td>
              </tr>
              <tr>
                <td height="28" align="right"><span style="font-weight: bold">文件上传截止时间：</span></td>
                <td style="padding-left:10px">{{ detail.UPEndTime }}</td>
              </tr>
              <tr>
                <td colspan="4" align="center"
                  style="padding-top:6px; padding-left:20px; padding-right:6px;">
                  <div v-for="(item, index) in detail.TenderChild">
                    <el-table :data="item" style="width: 100%;font-size: 15px;" :row-style="{}"
                      :cell-style="{ 'font-size': '15px' }" :header-row-style="{ 'font-weight': 'bold', 'color': '#666666' }"
                      :fit="true">
                      <el-table-column prop="PackNum" label="合同包号">
                      </el-table-column>
                      <el-table-column prop="Option" label="细项">
                      </el-table-column>
                      <el-table-column prop="Name" label="采购项目">
                      </el-table-column>
                      <el-table-column prop="Number" label="数量">
                      </el-table-column>
                      <el-table-column prop="Brand" label="品牌">
                      </el-table-column>
                      <el-table-column prop="ModelSetting" label="型号及设置">
                      </el-table-column>
                      <el-table-column prop="Price" label="单价">
                      </el-table-column>
                      <el-table-column prop="Unit" label="采购单位">
                      </el-table-column>
                      <el-table-column prop="TenderType" label="竞价类别">
                      </el-table-column>
                      <el-table-column prop="StartPrice" label="竞价起标价">
                      </el-table-column>
                      <el-table-column prop="Remark" label="备注">
                      </el-table-column>
                    </el-table>
                  </div>
                  <br style="line-height:10px">
                </td>
              </tr>
              <tr>
                <!-- <td height="40" align="right"><span style="font-weight: bold">附 件：</span></td> -->
                <td colspan="5" style="padding-left:30px;" v-html="detail.Content"></td>
              </tr>
              <td colspan="5" class="horizontal-line"></td>
              <tr>                
                <td height="18" colspan="6" style="padding-left:25px;">
                  <br style="line-height:6px">
                  <el-form v-for="(item, index) in Contact">
                    <el-col :span="12">
                      <el-form-item :label=item.Word_Text>
                        <span>{{ item.Word_Value }}</span>
                      </el-form-item>
                    </el-col>
                  </el-form>
                </td>
              </tr>
            </tbody>
          </table>

        </div>
      </div>
    </article>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: "Tenderdetail",
  components: {},
  data() {
    return {
      Id: 0,
      detail: "",
      Contact: []
    };
  },
  created() {
    this.Id = this.$route.query.id;
    this.getData();
    this.getContact();
  },
  methods: {
    getData() {
      var that = this;
      that.$api.get("/Tender/" + that.Id, null, r => {
        that.detail = r.response;
      });
    },
    getContact() {
      var that = this;
      that.$api.get("Config/GetGroupList", { groupkey: "Contact" }, r => {
        that.Contact = r.response;
        console.log(that.Contact)
      });
    }
  },
  watch: {
    $route(to) {
      this.getData();
      this.getContact();
    }
  },
  computed: {

  }
};
</script>

<style>
article.newhome {
  width: 1300px;
}

.el-table .cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

input::-webkit-input-placeholder {
  color: #999999;
  padding: 10px 0px 16px 10px;
}

.pagination {
  text-align: center;
}

.frame-border {
  width: 204px;
  border: 1px solid #EEEEEE;
}

.lmenu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #222222;
  font-size: 18px;
}

.el-table .cell {
  white-space: normal;
}

.el-form-item {
  margin-bottom: 0px;
}

.horizontal-line {
  border: none;
  height: 1px;
  background-color: #ccc;
}
</style>
